import React, { memo } from 'react';
import { GitHub } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
import { Project } from '../../data/projects';
import { useAnalytics } from '../../hooks/useAnalytics';

interface ProjectCardProps {
  project: Project;
  index: number;
}

const ProjectCard: React.FC<ProjectCardProps> = ({ project, index }) => {
  const { i18n } = useTranslation();
  const { trackEvent } = useAnalytics();
  const isPt = i18n.language.startsWith('pt');
  const isNpmProject = project.linkType === 'npm';

  const handleProjectClick = () => {
    trackEvent({
      name: 'project_click',
      properties: {
        projectTitle: project.title,
        projectLink: project.link,
        technologies: project.technologies,
      },
    });
  };

  return (
    <article className="game-mission-card">
      <div className="game-mission-card__top">
        <span className="game-mission-card__code">{isPt ? 'PROJETO' : 'PROJECT'} // {String(index + 1).padStart(2, '0')}</span>
        <span className="game-mission-card__status">
          {isNpmProject ? (isPt ? 'PACOTE NPM' : 'NPM PACKAGE') : (isPt ? 'CÓDIGO PÚBLICO' : 'PUBLIC CODE')}
        </span>
      </div>

      <div className="game-mission-card__visual">
        <img src={project.image} alt="" loading="lazy" />
      </div>

      <h3>{project.title}</h3>
      <p>{!isPt && project.descriptionEn ? project.descriptionEn : project.description}</p>

      <div className="game-mission-card__footer">
        <div className="game-mission-card__techs" aria-label={isPt ? 'Tecnologias' : 'Technologies'}>
          {project.technologies.slice(0, 4).map((technology) => (
            <span key={technology}>{technology}</span>
          ))}
        </div>

        <a
          className={`game-mission-card__link ${isNpmProject ? 'game-mission-card__link--npm' : ''}`}
          href={project.link}
          target="_blank"
          rel="noopener noreferrer"
          onClick={handleProjectClick}
          aria-label={`${isPt ? 'Abrir' : 'Open'} ${project.title} ${isNpmProject ? 'no npm' : 'no GitHub'}`}
          title={isNpmProject ? 'npm' : 'GitHub'}
        >
          {isNpmProject ? <span className="game-npm-wordmark" aria-hidden="true">npm</span> : <GitHub fontSize="small" />}
        </a>
      </div>
    </article>
  );
};

export default memo(ProjectCard);
